<dialog-gala (clickClose)="hideModal()">
  <span gala-dialog-titre>{{titre}}</span>
  <div class="mt-3 container justify-content-center">
    <table class="table table-striped">
      <thead>
        <tr>
          @for (head of headElements; track head) {
            <th class="align-middle"
              [ngClass]="(head.sortable)?'cursor-hand':'cursor-arrow'">
              {{head.libelle}}&nbsp;@if (head.sortable) {
              <cp-icon-sort [col]="sColTri === head.tri"
                [boo]="booAscendant" />
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (envoi of listeElementsAff; track envoi) {
        <tr>
          <td>{{ envoi.date | dateTimeFormat }}</td>
          <td>{{ envoi.destinataires[0].nom }} {{ envoi.destinataires[0].prenom }}</td>
          <!--<td>PDF</td>-->
          <td>{{ envoi.destinataires[0].typeEnvoi }}</td>
          @if (envoi.destinataires[0].typeEnvoi === 'Mail') {
            <td>@if (envoi.destinataires[0].email !== '') {
              <a
              href="mailto:{{ envoi.destinataires[0].email }}">{{ envoi.destinataires[0].email }}</a>
            }</td>
          }
          @if (envoi.destinataires[0].typeEnvoi === 'SMS') {
            <td>{{ envoi.destinataires[0].telephone }}</td>
          }
          <td><cp-icon-envoi [isComplet]="envoi.complet" /></td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div gala-dialog-actions>
  <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.RET}}</button>
</div>
</dialog-gala>